import React, {FC} from 'react';
import Helmet from 'react-helmet';
import HelpdeskSectionPageUI from '../../ui/Helpdesk/HelpdeskSectionPage/HelpdeskSectionPage';
import {ClientSideNavigationProvider} from '../../ui/Navigation/ClientSideLink/ClientSideLink';
import SeoFaqStructuredJson from './SeoFaqStructuredJson';
import {MAYA_ARTICLE_ID} from './constants';
import {filterHiddenSections} from './hiddenSections';
import useFilterVipSections from './hooks/useFilterVipSectionts';
import useRedirectVipOnlySection from './hooks/useRedirectVipOnlySection';
import {HelpCenterPageProps, HelpCenterSectionPageData} from './types';

const HelpCenterSectionPage: FC<
  HelpCenterPageProps<HelpCenterSectionPageData>
> = props => {
  useRedirectVipOnlySection(
    props.isVip,
    props.isCoinsActive,
    props.activeSectionId,
    props.navigateClient,
  );
  const sections = useFilterVipSections(
    props.isVip,
    props.isCoinsActive,
    props.sections,
  ).filter(filterHiddenSections);

  const articles = props.sectionArticles?.filter(
    article => article.id !== MAYA_ARTICLE_ID,
  );

  return (
    <>
      <Helmet
        title={props.translations.sectionPage.seo_page_title}
        meta={[
          {
            name: 'description',
            content: props.translations.sectionPage.seo_page_description,
          },
          {name: 'robots', content: 'index, follow'},
        ]}
        link={[{rel: 'canonical', href: props.canonicalUrl}]}
      />
      <ClientSideNavigationProvider navigateClient={props.navigateClient}>
        <HelpdeskSectionPageUI
          locale={props.locale}
          articles={articles}
          activeSection={props.activeSection}
          sections={sections}
          translations={props.translations}
          sectionId={props.activeSectionId}
          endpoints={props.endpoints}
          isShowOldHelpCenterEnabled={props.isShowOldHelpCenterEnabled}
        />
      </ClientSideNavigationProvider>
      {articles && <SeoFaqStructuredJson articles={articles} />}
    </>
  );
};

export default HelpCenterSectionPage;
